
<h2 class="popup-title">Contact Us</h2>
<button class="close-btn" (click)="closeDialog()">
  <i class="bi bi-x"></i>
</button>

<form [formGroup]="demoForm">
  <div class="form-group">
    <label>Name<span class="required">*</span></label>
    <input formControlName="name" placeholder="Enter your name" />
    <div class="error" *ngIf="demoForm.get('name')?.invalid && demoForm.get('name')?.touched">
      Name is required
    </div>
  </div>

  <div class="form-group">
    <label>Email<span class="required">*</span></label>
    <input formControlName="email" placeholder="Enter your email" />
    <div class="error" *ngIf="demoForm.get('email')?.invalid && demoForm.get('email')?.touched">
      <span *ngIf="demoForm.get('email')?.errors?.['required']">Email is required</span>
      <span *ngIf="demoForm.get('email')?.errors?.['email']">Enter a valid email</span>
    </div>
  </div>

  <div class="form-group">
    <label>Organization</label>
    <input formControlName="organization" placeholder="Your organization" />
    <div class="error" *ngIf="demoForm.get('organization')?.invalid && demoForm.get('organization')?.touched">
      Organization is required
    </div>
  </div>

  <div class="form-group">
    <label>How can we help you?</label>
    <textarea formControlName="description" placeholder="Message (optional)"></textarea>
  </div>

	 <!-- <div class="plan-input-wrapper">
     <input formControlName="plan" readonly class="plan-input" />
      </div> will display this value later -->
	
  <button type="submit" [disabled]="demoForm.invalid" (click)="postUpgradeUsagePlan()">
	<ng-container *ngIf="isLoading;else pageContent">
	<span class="spinner-border spinner-border-sm"></span> Sending...</ng-container>
<ng-template #pageContent>Submit</ng-template></button>
</form>